import config from "../Config/config";

const fetchAccountants = async (setAccountants) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/admin/accountants`, {
      credentials: "include",
    });
    const resJson = await response.json();
    const data = resJson.data;
    setAccountants(data.accountants);
  } catch (error) {
    console.error(`Failed to fetch accountants: ${error}`);
  }
};

const saveAccountants = async (accountants, setAlert) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/admin/accountants`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ accountants }),
    });
    if (response.ok) {
      setAlert({
        severity: "success",
        message: `Accountants saved`,
      });
    } else {
      setAlert({
        severity: "error",
        message: `Failed to save Accountants`,
      });
    }
  } catch (error) {
    console.error(`Failed to save accountants: ${error}`);
    setAlert({
      severity: "error",
      message: `Failed to save Accountants: ${error}`,
    });
  }
};

export { fetchAccountants, saveAccountants };
